import { TrainingCertificateDto } from '../dtos/training-certificate.dto';
import { Certificate, TrainingCertificate } from '../models/training-certificate';
import { activeMapper } from './active.mapper';
import { dateMapper } from './date.mapper';

/**
 * Map from dto.
 * @param {object} dto Dto.
 * @returns {Certificate}
 */
function certificateFromDto(dto) {
  return new Certificate({
    id: dto.id,
    name: dto.name,
    validityPeriod: dto.validity_period,
    createdDate: dateMapper.fromDto(dto.create_date),
    editedDate: dateMapper.fromDto(dto.edit_date),
    isActive: activeMapper.fromDto(dto.active),
  });
}

/**
 * Map from dto.
 * @param {TrainingCertificateDto} dto Dto.
 * @returns {TrainingCertificate}
 */
function fromDto(dto) {
  return new TrainingCertificate({
    id: dto.id,
    registrationId: dto.registration_id,
    code: dto.code,
    certificateId: dto.certificate_id,
    createdDate: dateMapper.fromDto(dto.create_date),
    certificate: dto.certificate ? certificateFromDto(dto.certificate) : null,
  });
}

export const trainingCertificateMapper = {
  fromDto,
};
